<template>
<div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="financeOffice_tooltip_NAME"  :name="financeOffice_tooltip_NAME" :description="financeOffice_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row col-md-12">
        <div class="col-md-6 align-center">
            <label>{{ usHeaderText }}</label>
        </div>
        <div class="col-md-6 align-center">
            <label>{{ partnerNationHeaderText }}</label>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-sm-6 ">

            <label for="usFinancialRepName" class="more-top-padding">U.S. Financial Representative Name</label>
            <base-input id="usFinancialRepName" v-validate="'required|max:300'" data-vv-as="U.S. Financial Representative Name" :disabled="isReadOnly || isPartnerAccount" :error="getError('usName')" v-model="financeOfficeInformation.usName" name="usName">
            </base-input>

            <label for="usFinanceOfficeName" class="more-top-padding">U.S. Finance Office Name:</label>
            <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="US_office_tooltip_name" :name="US_office_tooltip_name" :description="US_office_tooltip_description" :editable="editable"></tool-tip>
            <v-select id="usFinanceOfficeName" data-vv-as="U.S. Finance Office Name" v-validate="'required'" name="usFinanceOfficeName" :disabled="isReadOnly || isPartnerAccount" v-model="financeOfficeInformation.usOfficeId" :reduce="(o) => o.financialOfficeId" label="name" :options="usOffices" placeholder="Select office..."></v-select>
            <span v-show="errors.has('usFinanceOfficeName')" class="error">
                {{ errors.first("usFinanceOfficeName") }}
            </span>
            <br>

            <label for="usFinanceOfficeAddressOrEmail" class="more-top-padding">U.S. Finance Office Address and Email Address</label>
            <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="US_office_andEmailAddress_tooltip_name" :name="US_office_andEmailAddress_tooltip_name" :description="US_office_andEmailAddress_tooltip_description" :editable="editable"></tool-tip>

            <base-input id="usFinanceOfficeAddressandEmail" v-validate="'required|max:500'" data-vv-as="U.S. Finance Office Address and Email Address" :disabled="isReadOnly || isPartnerAccount" :error="getError('usFinanceOfficeAddress')" v-model="financeOfficeInformation.usAddress" name="usFinanceOfficeAddress">
            </base-input>
        </div>

        <div class="col-sm-6 ">
            <label for="partnerNationFinancialRepName" class="more-top-padding">Partner Nation Financial Representative Name</label>
            <base-input id="partnerNationFinancialRepName" :disabled="isReadOnly || isPartnerAccount" data-vv-as="Partner Nation Financial Representative Name" v-validate="'required|max:300'" :error="getError('partnerName')" v-model="financeOfficeInformation.partnerName" name="partnerName">
            </base-input>

            <label for="partnerNationFinanceOfficeName" class="more-top-padding">Partner Nation Finance Office Name:</label>
            <v-select id="partnerNationFinanceOfficeName" :disabled="isReadOnly || isPartnerAccount" name="partnerNationFinanceOfficeName" data-vv-as="Partner Nation Finance Office Name" :class="errors.has('partnerNationFinanceOfficeName') ? 'has-danger' : ''"
                      v-validate="'required'"
                      :error="getError('partnerNationFinanceOfficeName')" v-model="financeOfficeInformation.partnerOfficeId" :reduce="(o) => o.financialOfficeId" label="name" :options="pnOffices" placeholder="Select office..."></v-select>
            <span v-show="errors.has('partnerNationFinanceOfficeName')" class="error">
                {{ errors.first("partnerNationFinanceOfficeName") }}
            </span>
            <br>

            <label for="partnerNationFinanceOfficeAddressOrEmail" class="more-top-padding">Partner Nation Finance Office Address and Email Address</label>
            <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="partnerNation_address_tooltip_name" :name="partnerNation_address_tooltip_name" :description="partnerNation_address_tooltip_description" :editable="editable"></tool-tip>
            <base-input id="partnerNationFinanceOfficeAddressandEmail" v-validate="'required|max:500'" :disabled="isReadOnly || isPartnerAccount" data-vv-as="Partner Nation Finance Office Address and Email Address" v-model="financeOfficeInformation.partnerAddress" name="pnNationFinanceOfficeAddress" :error="getError('pnNationFinanceOfficeAddress')">
            </base-input>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 more-top-padding align-right">
            <base-button :disabled="isReadOnly || isPartnerAccount" type="primary" wide @click.native="submitForm" class="btn-next">Save</base-button>
            <div class="clearfix"></div>
        </div>
    </div>
    <Notifications :notifications="notificationMessages"> </Notifications>
</div>
</template>

<script>
import Notifications from "@/components/NotificationPlugin/Notifications.vue";
import {
    Select,
    Option
} from "element-ui";
import {
    mapActions,
    mapGetters
} from "vuex";
import Utility from "@/mixins/utility/utility";
import  toolTip  from "../../Tooltip";


export default {
    props: ["isReadOnly"],
    name: "FinanceOffice",
    mixins: [Utility],
    data() {
        return {
            notificationMessages: [],
            financeOffice_tooltip_NAME : '',
            financeOffice_tooltip_DESCRIPTION : '',
            US_office_tooltip_description: '',
            US_office_tooltip_name: '',
            US_office_andEmailAddress_tooltip_name: '',
            US_office_andEmailAddress_tooltip_description: '',
            partnerNation_address_tooltip_name: '',
            partnerNation_address_tooltip_description: '',
        };
    },

    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        Notifications,
        toolTip
    },
    computed: {
        ...mapGetters({
            preOrder: "preOrderDetail/preOrder",
            usOffices: "financialOffice/usOffices",
            pnOffices: "financialOffice/pnOffices",
            financeOfficeInformation: "financeOffice/financeOfficeInformation",
            financeOfficeInformationErrors: "financeOffice/financeOfficeInformationErrors",
            countryId: "financeOffice/partnerNationCountryId",
            orderIdFromPreOrderDetail: "preOrderDetail/preOrder",
            isPartnerAccount: "authentication/isPartnerAccount",
            toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
        }),
        usHeaderText() {
            if (this.preOrder.usBuySell == null) {
                return "Bill To:";
            }
            return this.preOrder.usBuySell == "BUY" ? "Bill To:" : "Pay To:";
        },
        partnerNationHeaderText() {
            if (this.preOrder.usBuySell == null) {
                return "Pay To:";
            }
            return this.preOrder.usBuySell == "SELL" ? "Bill To:" : "Pay To:";
        },
        orderIdFromRoute() {
            return parseInt(this.$route.params.id);
        },
    },
    async mounted() {
   await this.getAllTooltips()
   this.loadToolTips()
 },
    methods: {
        ...mapActions({
            getUsFinanceOffices: "financialOffice/getUsFinanceOffices",
            getPnFinanceOffices: "financialOffice/getPnFinanceOffices",
            getFinanceOfficeInformation: "financeOffice/getFinanceOfficeInformation",
            saveFinanceOfficeInformation: "financeOffice/saveFinanceOfficeInformation",
            clearPartnerFields: "financeOffice/clearPartnerFields",
            getPNCountry: "financeOffice/getPartnerNationCountryId",
            getFinanceOfficeStatus: "financeOffice/getFinanceOfficeInformationStatus",
            getAllTooltips: "tooltip/getToolTips"
        }),
       
        loaded() {
            let ctx = this;
            ctx.getPNCountry(ctx.orderIdFromRoute).then(() => {
                ctx.fetchInitialData(ctx.orderIdFromRoute);
            });

            this.getUsFinanceOffices();
        },
        loadToolTips(){
            const USOfficeToolTip = this.toolTips.find(e => e.name === "USOffice");
            const financeOfficeVal = this.toolTips.find(e => e.name === "FinanceOfficeModule");
            const USOfficeAddressToolTip = this.toolTips.find(e => e.name === "USOfficeAddress");
            const PartnerNationAddressToolTip = this.toolTips.find(e => e.name === "PartnerNationAddress");
            if (USOfficeAddressToolTip.status) {
                this.US_office_andEmailAddress_tooltip_description = USOfficeAddressToolTip.description ? USOfficeAddressToolTip.description : null
                this.US_office_andEmailAddress_tooltip_name = USOfficeAddressToolTip.name ? USOfficeAddressToolTip.name : null
            }
            if (PartnerNationAddressToolTip.status) {
                this.partnerNation_address_tooltip_description = PartnerNationAddressToolTip.description ? PartnerNationAddressToolTip.description : null
                this.partnerNation_address_tooltip_name = PartnerNationAddressToolTip.name ? PartnerNationAddressToolTip.name : null
            }
    if(USOfficeToolTip.status){
      this.US_office_tooltip_description = USOfficeToolTip.description ? USOfficeToolTip.description :  null
      this. US_office_tooltip_name = USOfficeToolTip.name ? USOfficeToolTip.name :  null
    }
    if(financeOfficeVal.status){
    this.financeOffice_tooltip_DESCRIPTION = financeOfficeVal.description ? financeOfficeVal.description: null
      this.financeOffice_tooltip_NAME = financeOfficeVal.name ? financeOfficeVal.name: null
            }
    return },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
        fetchInitialData(orderId) {
            if (orderId > 0) {
                //this.saveOrderId(this.orderId);
                if (this.countryId) {
                    this.getPnFinanceOffices(this.countryId);
                }
                this.getFinanceOfficeInformation(orderId);
            } else {
                this.$store.dispatch("financeOffice/clearData");
            }
        },
        showAlertDialog(alertHeaderText, alertBodyText) {
            this.$toast.error(`${alertHeaderText}: ${alertBodyText}`);
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        showFinanceOfficeInformationErrors () {
            if(this.financeOfficeInformationErrors !== undefined && this.financeOfficeInformationErrors.length > 0 ) {
                this.financeOfficeInformationErrors.forEach(error => this.$toast.error(error))
            } 
        },
        async submitForm(e) {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    let ctx = this;
                    if (ctx.orderIdFromRoute > 0) {
                        //use ctx this looses its context in a callback
                        ctx.saveFinanceOfficeInformation(ctx.orderIdFromRoute)
                            .then((result) => {
                                ctx.getFinanceOfficeStatus(this.$route.params.id).then(() => {
                                    ctx.showFinanceOfficeInformationErrors();
                                });
                                ctx.getFinanceOfficeInformation(ctx.orderIdFromRoute);
                            })
                            .catch((error) => {
                                this.$toast.error(error);
                            });
                    }
                } else {
                    this.$toast.error("Please fill the form fields first.");
                }
            });
        },
    },
};
</script>

<style scoped>
</style>
